import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormHelperText, makeStyles } from '@material-ui/core';
import CustomButton from '../customButton';
import { replaceObjectInList } from '../../../utility/helpers';
import TextField from './textField';

const useStyles = makeStyles(({ spacing }) => ({
  label: {
    fontFamily: 'ProximaNova-Bold',
    fontSize: 20,
    lineHeight: '24px',
    marginBottom: spacing(4),
    marginRight: spacing(1),
  },
}));

const TextFields = ({
  translations,
  values = [],
  initialValues,
  fieldTypes,
  error = null,
  isDisabled = false,
  onChange,
  ...rest
}) => {
  const classes = useStyles();

  const handleAddField = useCallback(() => {
    return onChange([...values, { ...initialValues }]);
  }, [values, initialValues, onChange]);

  const handleDeleteValue = useCallback(
    fieldIndex => () => {
      const updatedValues = values.filter((val, index) => index !== fieldIndex);

      return onChange(updatedValues);
    },
    [values, onChange]
  );

  const handleChangeValue = useCallback(
    (field, fieldIndex) => {
      onChange(replaceObjectInList(values, fieldIndex, field));
    },
    [values, onChange]
  );

  return (
    <div>
      {translations.label && (
        <FormHelperText classes={{ root: classes.label }}>
          {translations.label}
        </FormHelperText>
      )}
      {values.map((val, index) => (
        <TextField
          key={`item_${index}`}
          id={index}
          translations={translations.field}
          value={val}
          fieldTypes={fieldTypes}
          error={error?.[index]}
          isDisabled={isDisabled}
          onDelete={handleDeleteValue(index)}
          onChange={handleChangeValue}
          {...rest}
        />
      ))}
      <CustomButton
        disabled={isDisabled}
        type="addDarkRoundedOutlined"
        onClick={handleAddField}
      >
        {translations.addFieldButton}
      </CustomButton>
    </div>
  );
};

TextFields.propTypes = {
  translations: PropTypes.object.isRequired,
  values: PropTypes.arrayOf(PropTypes.object),
  fieldTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  initialValues: PropTypes.object.isRequired,
  isDisabled: PropTypes.bool,
  error: PropTypes.object,
  onChange: PropTypes.func.isRequired,
};

export default TextFields;
